export default function not(fn) {
    return function notF(...args) {
        return !fn(...args);
    };
}
//# sourceMappingURL=not.js.map